import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import BrandLogo from './BrandLogo';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <span className="app-footer-wordmark">
          <BrandLogo height={15} />
        </span>
        <nav className="info-links">
          <Link to="/about">Über uns</Link>
          <Link to="/impressum">Impressum</Link>
          <Link to="/datenschutz">Datenschutz</Link>
          <a
            href="https://www.instagram.com/elf_halbe/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
        </nav>
        <span className="app-footer-copyright">© {new Date().getFullYear()} ELFHALBE</span>
      </div>
    </footer>
  );
};

export default Footer;
